export { getValidLinkType } from './get-valid-link-type';
export { handleNavigation } from './handle-navigation';